import styled from 'styled-components';
import { Row, Button } from 'antd';
import { SecondaryButtonComponent } from '../../../commonStyles';

export const TourContainerWrapper = styled.div`
  position:fixed;
  top:120px;
  width: 100%;
  z-index: 998;
`
export const TourContainer = styled.div`
  border-bottom: 2px solid #006778; 
  background: #eaeaea;
  width: 100%;
  padding: 10px 0px;
  height: auto;
  @media only screen and (max-width: 1024px) and (min-width: 900px) {
    padding: 0 10px 0 20px;
  }
`;
export const TourContainer_SecNav = styled.div`
  border-bottom: 2px solid #006778;
  border-top: 2px solid #006778;
  background: #fff1d0;
  z-index: 998;
  width: 100%;
  padding: 10px 0px;
  height: auto;
  @media only screen and (max-width: 1024px) and (min-width: 900px) {
    padding: 10px 10px 10px 20px;
  }
`;
export const TourBtn = styled.div`
  background-image: url(${props => props.backgroundImage});
  background-repeat: no-repeat;
  position: absolute;
  right: 0;
  bottom: ${props => (props.isOpen ? '-74px' : '-38px')};
  border: none;
  width: 165px;
  height: 28px;
  font-family: HelveticaNeue;
  cursor: pointer;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 25px;
  letter-spacing: 0px;
  text-align: center;
  color: white;
  background-size: 160px 25px;
  @media only screen and (max-width: 576px) {
    right: 0%;
  }

  @media only screen and (max-width: 425px) {
    bottom: ${props => props.isOpen ? '-48px' : '-39px'};
  }
`;
export const TourBtn1 = styled.div`
  background-image: url(${props => props.backgroundImage});
  background-repeat: no-repeat;
  position: absolute;
  right: 0;
  bottom:-38px;
  border: none;
  width: 165px;
  height: 28px;
  font-family: HelveticaNeue;
  cursor: pointer;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 25px;
  letter-spacing: normal;
  text-align: center;
  color: white;
  background-size: 160px 25px;
  @media only screen and (max-width: 576px) {
    right: 0%;
  }
`;
export const DisplayFlexContainer = styled(Row)`
  height: auto;
  overflow: auto;
  margin: 36px 0;
  @media only screen and (max-width: 576px) {
    height: 350px;
    margin: 10px 0;
  }
`;

export const DisplayFlexContainer_SecNavbar= styled(Row)`
  height: auto;
  overflow: auto;
  margin: 16px 0;
  @media only screen and (max-width: 576px) {
    height: 350px;
    margin: 10px 0;
  }
`;
export const TourTextContainer = styled.div`
  height: fit-content;
  font-family: HelveticaNeue;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0px;
  color: #606060;
`;
export const TourTextContainer_SecNav = styled.div`
width: 1160px;
height: 20px;
font-family: HelveticaNeue;
font-size: 14px;
font-weight: normal;
font-style: normal;
font-stretch: normal;
line-height: 1.43;
letter-spacing: normal;
color: #505050;
`;
export const OldLink = styled.a`
  color: #006778;
  text-decoration: underline;
  &:hover {
    color: #006778;
    text-decoration: underline;
  }
`;
export const OldLink1 = styled.a`
   color: #006778;
   text-decoration: underline;
  width:1px;
  font-weight: bold;
  height: 13px;
  &:hover {
    color: #006778;
    text-decoration: underline;
    width:1px;
  }
`;
export const Seprator = styled.span`
   display:inline-block;
   margin: 0 9px -3px 9px;
   border-left: 1px solid #927474;
   height: 14px;

`;
export const TourButtonsContainer = styled(Row)`
  margin-top: 25px;
  @media only screen and (max-width: 576px) {
    margin-top: 20px;
  }
`;
export const TourButtonsContainer_SecNav = styled(Row)`
  margin-top: 25px;
  @media only screen and (max-width: 576px) {
    margin-top: 20px;
  }
`;
export const Img = styled.img`
  @media (max-width: 576px) {
    width: 316px;
    margin-bottom: 10px;
  }
  @media (max-width: 374px) {
    width: 100%;
    margin-bottom: 10px;
  }
`;

export const HeadingComponent = styled.div`
  font-family:BerkeleyStd-Bold, HelveticaNeue, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 24px;
  line-height: 1.5;
  letter-spacing: 0px;
  color: #006778;
  margin-bottom: 10px;
  @media (max-width: 576px) {
  font-size: 20px;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  }
`;
export const HeadingComponent_SecNavbar = styled.div`
  font-family: BerkeleyStd;
  font-size: 24px;
  font-weight: bold;
  line-height: 1.5;
  letter-spacing: 0.3px;
  color: #006778;
  margin-bottom: 10px;
`;
export const TextContent = styled.div`
  font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0px;
  color: #505050;
  @media (max-width: 576px) {
  font-size: 14px;
  line-height: 1.43;
  }
`;
export const TextContent1 = styled.div`
  font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.5px;
  color: #606060;
`;
export const TextContent3 = styled.div`
  font-weight: bold;
  color: #006778;
`;
export const FixedWidth = styled.div`
  position: relative;
  max-width: 1180px;
  margin: 0 auto;
  @media (max-width: 1440px) {
    padding-left: 25px;
    padding-right: 25px;
  }
  @media (max-width: 576px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;
export const FixedWidth_SecNavbar = styled.div`
  position: relative;
  max-width: 1180px;
  margin: 0 auto;
  @media (max-width: 1440px) {
    padding-left: 25px;
    padding-right: 25px;
  }
  @media (max-width: 576px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const TourButtons = styled(Button)`
  border-radius: 18px;
  border: solid 1px #d4d4d4;
  width: fit-content;
  padding: 1px 10px 3px 10px;
  color: white;
  background-color: ${props => props.theme.backgroundColor.primaryColor};
  margin-right:10px;
  font-family:HelveticaNeue-Medium , HelveticaNeue, 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Segoe UI Symbol';
  &:hover,
  :focus {
    background-color: ${props => props.theme.colors.primaryColor};
    color: ${props => props.theme.colors.white};
  }
`;
export const TourButtons_SecNavbar = styled(Button)`
  border-radius: 18px;
  border: solid 1px #d4d4d4;
  width: fit-content;
  padding: 1px 10px 3px 10px;
  color: white;
  background-color: #006778;
  &:hover,
  :focus {
    background-color: ${props => props.theme.colors.primaryColor};
    color: ${props => props.theme.colors.white};
  }
`;
export const TourButtonsReverse = styled(SecondaryButtonComponent)`
  font-family:HelveticaNeue-Medium , HelveticaNeue, 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Segoe UI Symbol';
  margin-left:20px;
  font-size:14px;
   width: fit-content;
   padding: 1px 20px 3px 20px;
  @media only screen and (max-width: 991px) {
    margin-top: 10px;
    margin-left:0;
    font-size:14px;
  }
`;
export const TourButtonsReverse_SecNav = styled(SecondaryButtonComponent)`
  @media only screen and (max-width: 576px) {
    margin-top: 20px;
  }
`;

export const EmptyProductTourContainer = styled.div`
  border-top: 2px solid ${props => props.theme.border.teal};
`;
